export default "__VITE_ASSET__DVQiddV8__"